var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 50",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.97 3C9.256 3 3 9.248 3 16.954c0 13.954 16.51 26.64 25.401 29.59 8.89-2.95 25.401-15.636 25.401-29.59C53.802 9.248 47.547 3 39.832 3a13.958 13.958 0 00-11.43 5.93A13.949 13.949 0 0016.97 3z",
    stroke: "url(#heart_svg__a)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heart_svg__a",
    x1: 51.348,
    y1: 3.831,
    x2: 43.517,
    y2: 50.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4888E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1658BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NyA1MCI+CiAgPHBhdGggZD0iTTE2Ljk3MDYgM0M5LjI1NTAzIDMgMyA5LjI0NzY5IDMgMTYuOTU0MmMwIDEzLjk1NDMgMTYuNTEwNyAyNi42Mzk5IDI1LjQwMTEgMjkuNTkwNiA4Ljg5MDQtMi45NTA3IDI1LjQwMTItMTUuNjM2MyAyNS40MDEyLTI5LjU5MDZDNTMuODAyMyA5LjI0NzY5IDQ3LjU0NzMgMyAzOS44MzE3IDNjLTQuNzI0NyAwLTguOTAzMSAyLjM0MzA1LTExLjQzMDYgNS45MjkyOC0xLjI4ODItMS44MzI4Mi0yLjk5OTYtMy4zMjg2LTQuOTg5My00LjM2MDcxQzIxLjQyMjEgMy41MzY0NiAxOS4yMTI3IDIuOTk4NDIgMTYuOTcwNiAzWiIgc3Ryb2tlPSJ1cmwoI2EpIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNTEuMzQ4MSIgeTE9IjMuODMxMjEiIHgyPSI0My41MTcyIiB5Mj0iNTAuMTg2NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNDg4OEU4Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE2NThCQSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };